import { CancelToken } from "axios";
import { AdminType, APIGet, APIPost, APIPut, APIUrl, IAPIResponse } from "api/protocols";
import { ICustomer } from "redux/reducers/models/customer";

interface IEmailRainCheck {
  code?: string;
  id?: number;
  customer_email: string;
}

interface IGetRainCheck {
  id?: number;
  customer_id?: number;
  code?: string;
  offset?: number;
  limit?: number;
  search?: string;
  filters?: Array<Record<string, any>>;
}

export interface IRainCheck {
  id: number;
  last4: string;
  balance: number;
  currency: string;
  facility_id: number;
  client_id: number;
  customer_id: number;
  status: string;
  order_id: number;
  expires_at: string;
  note: string;
  admin_id: number;
  created_at: string;
  customer: ICustomer;
  expiry_date: string;
  redeemed_at?: string | null;
}

interface IPutCalculateRainCheck {
  order_id: number;
  booking_participant_id: number;
  issue_on_green_fee: boolean;
  issue_on_power_cart: boolean;
  amount: number | null;
  percent: number | null;
}

interface IRedeemRainCheck {
  cart_id: number;
  rain_check_code: string;
  rain_check_id: number;
}

interface IGetRainCheckResponse extends IAPIResponse {
  data: IRainCheck[];
}

interface IPutRainCheck {
  id: number;
  customer_id?: number;
  status?: string;
}

export async function GetRainChecks(
  params: IGetRainCheck,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IGetRainCheckResponse> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check"), params, useGlobalLoader, token);
}

export async function GetRainCheckReceipt(params: { id: number }, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check/receipt"), params, useGlobalLoader);
}

export async function EmailRainCheckReceipt(params: IEmailRainCheck, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check/email"), params, useGlobalLoader);
}

export async function PutRainCheck(params: IPutRainCheck, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check"), params, useGlobalLoader);
}

export async function PostIssueRainCheck(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check/issue"), params, useGlobalLoader);
}

export async function PutCalculateRainCheck(params: IPutCalculateRainCheck, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check/calculate"), params, useGlobalLoader);
}

export async function PostRedeemRainCheck(params: IRedeemRainCheck, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/rain-check/redeem"), params, useGlobalLoader);
}
